import styled, { css } from "styled-components";

export const Wrapper = styled.div`
  position: absolute;
  left: 1.5rem;
  bottom: 1.5rem;
`;

export const Container = styled.div`
  background-color: var(--black-300);
  border-radius: 4px;
  padding: 1.25rem;
  z-index: 999;
  width: 20.625rem;
`;

export const Header = styled.header`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled.p`
  font-size: 1rem;
  font-family: DM Sans;
  font-weight: 500;
  padding: 0;
  max-width: 15.625rem;
  white-space: nowrap;
  overflow: hidden;
  padding-right: 1.2rem;
  text-overflow: ellipsis;
`;

export const CoordinateText = styled.span`
  font-family: Inter;
  color: var(--primary);
  font-weight: 500;
`;

export const CloseButton = styled.button`
  background-color: var(--black-400);
  padding: 0rem;
  width: 30px;
  height: 30px;
  border-radius: 100%;
  margin-left: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.4s;

  &:hover {
    background-color: var(--black-100);
  }

  img {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const ButtonContainer = styled.div`
  margin: 0.8rem 0rem 0rem 0rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid rgba(56, 56, 56, 0.64);
`;

export const PopupButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: var(--black-400);
  color: var(--white);
  font-size: 0.8rem;
  font-family: Inter;
  border-radius: 4px;
  padding: 0.55rem;
  margin-bottom: 0.5rem;
  transition: background 0.4s;

  &:hover {
    background-color: var(--black-100);
  }
`;

type WorkingStatusProps = {
  available: boolean;
  isSkeleton?: boolean;
};

export const WorkingStatus = styled.div<WorkingStatusProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem;
  background-color: var(--black-200);
  border-radius: 0.3rem;
  margin-top: 1rem;

  img {
    width: 1.7rem;
    height: 1.7rem;
    padding: 0.3rem;
    background: var(--black-100);
    border-radius: 4px;
  }

  ${({ isSkeleton }) =>
    isSkeleton &&
    css`
      padding: 0;
      background: transparent;
    `}

  ${({ available }) =>
    available &&
    css`
      color: var(--primary);
      background: var(--darker-primary);
      justify-content: center;
    `}
`;

type InfoProps = {
  isSkeleton?: boolean;
};

export const Info = styled.div<InfoProps>`
  display: flex;
  flex-direction: row;
  align-items: center;

  ${({ isSkeleton }) =>
    isSkeleton &&
    css`
      width: 100%;
    `}
`;

type DescriptionProps = {
  available: boolean;
};

export const Description = styled.div<DescriptionProps>`
  margin-left: 0.5rem;

  p {
    font-size: 14px;
    color: var(--white);
    margin: 0;

    width: auto;
  }

  ${({ available }) =>
    available &&
    css`
      p {
        color: var(--primary);
      }
    `}
`;
